import d3 from 'd3';
import {
  Measure
} from '../common/measure';

require('./pie.component.scss');

/*@ngInject*/
const allOther = gettext('Всё остальное');
const other = gettext('Oстальное');

const maxLegends = 20;
const maxSegments = 10;
const startColor = '#0088cc';
const CaptionsFontSize = 14;
const CaptionsFontFamily = 'sans-serif';
let totalSize;

const browserText = (function() {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  /**
   * Measures the rendered width of arbitrary text given the font size and font face
   * @param {string} text The text to measure
   * @param {number} fontSize The font size in pixels
   * @param {string} fontFace The font face ("Arial", "Helvetica", etc.)
   * @returns {number} The width of the text
   **/
  function getWidth(text) {
    context.font = `${CaptionsFontSize}px ${CaptionsFontFamily}`;
    return context.measureText(text).width;
  }
  return {
    getWidth: getWidth
  };
}());

class PieController {
  constructor(
    $scope,
    $rootScope,
    $element, RouterService,
    rx,
    $timeout,
  ) {
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$element = $element;
    this.router = RouterService;
    this.legendWidth = 0;
    this.$timeout = $timeout;
    this.showCaptions = true;
    this.fontColor = $rootScope.theme == 'dark' ? '#eee' : 'black';
    const subscriptions = [
      rx.Observable.merge(
        rx.Observable.merge(
          $scope.$eventToObservable('dashboardResize'),
          $scope.$eventToObservable('resize'),
          $scope.$eventToObservable('splitter1Changed')
        ).debounce(100),
        rx.Observable.merge(
          $scope.$toObservable('$ctrl.filter.orders'),
          $scope.$toObservable('$ctrl.filter.orderDirs'),
          $scope.$toObservable('$ctrl.aggregate'),
        ).debounce(100),

        $scope.$eventToObservable('resizeBeforePrint'),
        $scope.$eventToObservable('afterPrint'),
        $scope.$eventToObservable('init')
      ).subscribe(e => {
        this.render();
      })
    ];

    $scope.$on('$destroy', () => {
      subscriptions.forEach(subscription => {
        subscription.dispose();
      });
    });
  }

  $postLink() {}

  hideCaptions() {
    this.showCaptions = !this.showCaptions;
    this.render();
  }

  get aggregate() {
    return this._aggregate;
  }

  set aggregate(value) {
    this._aggregate = value;
    if (!this.legendWidth) {
      this.$timeout(this.render(), 0);
    } else this.render();
  }

  render() {
    const _this = this;
    const isDashboardPdf = this.router.pdf && this.router.CurrentFilterService.filter.isCardOrDashboard;
    const statChart = this.$element[0].querySelector('.stat-chart');
    const statSequence = this.$element[0].querySelector('.stat-sequence');
    const statLegend = this.$element[0].querySelector('.stat-legend');
    const fontColor = this.fontColor;
    const aggregate = this.aggregate;
    const drills = aggregate.filter.drilldown;
    const sortKeys = {
      orders: this.filter.orders,
      orderDirs: this.filter.orderDirs,
      drill1: this.model.getDrillAttr(this.filter.drilldown[0])
    };

    if (!aggregate || !aggregate.cells) {
      return;
    }

    this.$element.find('svg').remove();

    const width = this.$element.width();

    const buildHierarchy = csv => {
      if (!aggregate || !aggregate.filter || !aggregate.filter.drilldown) {
        return null;
      }
      const root = {
        name: 'root',
        children: []
      };

      for (let i = 0; i < csv.length; i++) {
        const size = csv[i][_this.aggregate.filter.measure];
        const parts = [];

        for (let j = 0; j < drills.length; j++) {
          const filter = _this.model.getCellFilter(drills[j], csv[i]);
          filter.data = size;
          if (!filter.label) {
            filter.label = gettext('Значение не указано');
          }
          parts.push(filter);
        }
        let currentNode = root;
        for (let j = 0; j < parts.length; j++) {
          const maxChildern = j ? maxSegments : maxLegends;
          const children = currentNode['children'];
          const filter = parts[j];
          const nodeName = filter.label;
          let childNode;
          if (j + 1 < parts.length) {
            // Not yet at the end of the sequence; move down the tree.
            let foundChild = false;
            for (let k = 0; k < children.length; k++) {
              if (children[k]['name'] === nodeName) {
                childNode = children[k];
                foundChild = true;
                break;
              }
            }
            // If we don't already have a child node for this branch, create it.
            if (!foundChild) {
              if (children.length < maxChildern - 1) {
                childNode = {
                  name: nodeName,
                  filter: filter,
                  children: [],
                };
                children.push(childNode);
              } else if (children.length === maxChildern - 1) {
                childNode = {
                  name: allOther,
                  filter: {
                    data: filter.data,
                    dimension: filter.dimension,
                    label: allOther,
                    text: allOther,
                    value: '',
                  },
                  children: [],
                };
                children.push(childNode);
              } else {
                const ch = children[children.length - 1];
                ch.filter.data += filter.data;
              }
            }
            currentNode = children[children.length - 1];
          } else {
            // Reached the end of the sequence; create a leaf node.
            if (children.length < maxChildern - 1) {
              childNode = {
                name: nodeName,
                filter: filter,
                size: size
              };
              children.push(childNode);
            } else if (children.length === maxChildern - 1) {
              childNode = {
                name: allOther,
                filter: {
                  data: filter.data,
                  dimension: filter.dimension,
                  label: allOther,
                  text: allOther,
                  value: '',
                },
                size: size
              };
              children.push(childNode);
            } else {
              const ch = children[children.length - 1];
              ch.size += size;
              ch.filter.data += filter.data;
            }
          }
        }
      }
      return root;
    };

    const getLegendWidth = g => {
      // const legend = _this.$element.find('.stat-legend');
      // const k = legend.width() / legend[0].getBoundingClientRect().width;
      const legendW = g[0].reduce((mw, l) => {
        const w = l.getBoundingClientRect().width;
        if (mw < w) mw = w;
        return mw;
      }, 0);
      return Math.round(legendW);
    };

    // Mapping of step names to colors.
    const getColor = label => {
      if (label === allOther) return startColor;
      if (label in colors) return colors[label];
      return startColor;
    };

    const json = buildHierarchy(aggregate.cells);
    // Dimensions of sunburst.

    const prt = d3.layout.partition().value(d => d.size);
    const nd = prt.nodes(json);

    const color = [d3.scale.category10(), () => startColor];

    const colors = nd[0].children ? nd[0].children.reduce((acc, n, i) => {
      acc[n.name] = color[0](i % 10);
      return acc;
    }, {}) : {};

    drawLegend(nd[0]);


    let height = Math.min(
      this.$element.width() - _this.maxLegendWidth / (isDashboardPdf ? 2 : 1),
      this.$element.height() - (isDashboardPdf ? 15 : 50)
    );

    if (isDashboardPdf) height *= 3; //this.$element.closest('sc-dashboard').width() / this.$element.width();
    if (height > 650) height = 650;
    if (height < 50) height = 50;

    _this.height = Math.round(height);
    const radius = height / 2;
    if (height < 50 || width < 50) return;
    // Breadcrumb dimensions: width, height, spacing, width of tip/tail.
    const b = {
      w: 175,
      h: 30,
      s: 3,
      t: 10
    };

    // Total size of all segments; we set this later, after loading the data.

    const vis = d3
      .select(statChart)
      .append('svg:svg')
      .attr('width', height)
      .attr('height', height)
      .append('svg:g')
      .attr('id', 'stat-container')
      .attr('transform', 'translate(' + (height / 2) +
        ',' + (height / 2) + ')');


    const partition = d3.layout
      .partition()
      .size([2 * Math.PI, radius * radius])
      .value(d => d.size);

    const arc = d3.svg
      .arc()
      .startAngle(d => d.x)
      .endAngle(d => d.x + d.dx)
      .innerRadius(d => d.innerRadius)
      .outerRadius(d => d.outerRadius);


    // Main function to draw and set up the visualization, once we have the data.
    function createVisualization(json) {
      // Basic setup of page elements.
      initializeBreadcrumbTrail();

      // Bounding circle underneath the sunburst, to make it easier to detect
      // when the mouse leaves the parent g.
      vis
        .append('svg:circle')
        .attr('r', radius)
        .style('opacity', 0);

      const nodes = partition.nodes(json)
        .map(d => {
          d.captionName = d.name;
          d.captionWidth = browserText.getWidth(d.name);
          d.outerRadius = Math.sqrt(d.y);
          d.innerRadius = d.y - d.dy > 0 ? Math.sqrt(d.y - d.dy) : 0;
          const length = d.depth > 1 ? ((d.outerRadius + d.innerRadius) / 2) * d.dx - 10 :
            d.outerRadius - (CaptionsFontSize / d.dx);
          if (length <= 0) d.captionName = '';
          else if (length < d.captionWidth) {
            d.captionName = d.name.substr(0, Math.floor(d.name.length * length / d.captionWidth * 0.9));
            if (d.captionName.length && d.captionName.length < d.name.length) d.captionName += '...';
            d.captionWidth = browserText.getWidth(d.captionName);
          }
          return d;
        });

      const path = vis
        .data([json])
        .selectAll('path')
        .data(nodes)
        .enter()
        .append('svg:path')
        .attr('display', d => (d.depth ? null : 'none'))
        .attr('d', arc)
        .attr('fill-rule', 'evenodd')
        .style('fill', d => getColor(d.name))
        .style('opacity', 1)
        .style('cursor', 'pointer')
        .on('mouseover', mouseover)
        .on('click', mouseclick)
        .append('text');

      if (_this.showCaptions) {
        const captionsPath = d => {
          if (!d.outerRadius) return null;
          const angle = d.x + d.dx / 2;
          if (d.depth === 1) {
            const sinAngle = Math.sin(angle);
            const cosAngle = Math.cos(angle);
            const dX = CaptionsFontSize / 3. * cosAngle;
            const dY = CaptionsFontSize / 3. * sinAngle;
            const x1 = (d.outerRadius * 0.95 - d.captionWidth) * sinAngle;
            const y1 = -(d.outerRadius * 0.95 - d.captionWidth) * cosAngle;
            const x2 = d.outerRadius * 0.95 * sinAngle;
            const y2 = -d.outerRadius * 0.95 * cosAngle;
            if (angle < Math.PI)
              return d3.svg.line()([
                [x1 + dX, y1 + dY],
                [x2 + dX, y2 + dY],
              ]);
            else
              return d3.svg.line()([
                [x2 - dX, y2 - dY],
                [x1 - dX, y1 - dY],
              ]);
          }
          const midRadius = (d.outerRadius + d.innerRadius) / 2;
          const pathRadius = angle > Math.PI / 2. && angle < Math.PI * 3. / 2. ?
            midRadius + CaptionsFontSize / 3 : midRadius - CaptionsFontSize / 3;
          let dA = 0;
          if (midRadius * d.dx > d.captionWidth) {
            dA = (midRadius * d.dx - d.captionWidth) / 2 / midRadius;
          }
          return d3.svg
            .arc()
            .startAngle(d => angle > Math.PI / 2. && angle < Math.PI * 3. / 2. ? d.x + d.dx - dA : d.x + dA)
            .endAngle(d => angle > Math.PI / 2. && angle < Math.PI * 3. / 2. ? d.x : d.x + d.dx)
            .innerRadius(d => pathRadius)
            .outerRadius(d => pathRadius)(d);
        };

        vis
          .data([json])
          .selectAll('.captionsPath')
          .data(nodes)
          .enter()
          .append('path')
          .attr('class', 'captionsPath')
          .attr('id', (d, i) => 'id_pie_segment_' + _this.filter.id + '_' + i)
          .attr('d', captionsPath);

        vis
          .data([json])
          .selectAll('.captionsText')
          .data(nodes)
          .enter()
          .append('text')
          .append('textPath')
          .attr('xlink:href', (d, i) => '#id_pie_segment_' + _this.filter.id + '_' + i)
          .attr('class', 'captionsText')
          .on('mouseover', mouseover)
          .style('cursor', 'pointer')
          .style('font-size', CaptionsFontSize)
          .style('font-family', CaptionsFontFamily)
          .on('click', mouseclick)
          .text(d => d.captionName);
      }

      // Add the mouseleave handler to the bounding circle.
      vis.on('mouseleave', mouseleave);

      // Get total size of the tree = value of root node from partition.
      totalSize = path.node() ? path.node().__data__.value : 0;
    }

    function mouseclick(d) {
      if (!d.filter.value) return;
      _this.router.drilldownFilter(d.filter);
      _this.$rootScope.$digest();
    }

    // Fade all but the current sequence, and show it in the breadcrumb trail.
    function mouseover(d) {
      const sequenceArray = getAncestors(d);
      const cell = {};
      cell[_this.aggregate.filter.measure] = d.value;
      const val = Measure.getMeasure(cell, _this.aggregate.filter.measure);
      updateBreadcrumbs(sequenceArray, val, d.value);

      // Fade all the segments.
      d3.selectAll('path').style('opacitthis.$element.height()', 0.3);

      // Then highlight only those that are an ancestor of the current segment.
      vis
        .selectAll('path')
        .filter(node => sequenceArray.indexOf(node) >= 0)
        .style('opacity', 1);
    }

    // Restore everything to full opacity when moving off the visualization.
    function mouseleave() {
      // Hide the breadcrumb trail
      d3.select(statSequence)
        .select('#stat-trail')
        .style('visibility', 'hidden');

      // Deactivate all segments during transition.
      //               d3.selectAll("path").on("mouseover", null);

      // Transition each segment to full opacity and then reactivate it.
      d3.select(statChart)
        .selectAll('path')
        .transition()
        .duration(1000)
        .style('opacity', 1)
        .each('end', function() {
          d3.select(this).on('mouseover', mouseover);
        });
    }

    // Given a node in a partition layout, return an array of all of its ancestor
    // nodes, highest first, but excluding the root.
    function getAncestors(node) {
      const path = [];
      let current = node;
      while (current.parent) {
        path.unshift(current);
        current = current.parent;
      }
      return path;
    }

    function initializeBreadcrumbTrail() {
      // Add the svg area.
      const trail = d3
        .select(statSequence)
        .append('svg:svg')
        .attr('width', width)
        .attr('height', 50)
        .attr('id', 'stat-trail');
      // Add the label at the end, for the percentage.
      trail
        .append('svg:text')
        .attr('id', 'stat-endlabel')
        .style('fill', fontColor);

    }

    // Generate a string that describes the points of a breadcrumb polygon.
    function breadcrumbPoints(d, i) {
      const points = [];
      points.push('0,0');
      points.push(b.w + ',0');
      points.push(b.w + b.t + ',' + b.h / 2);
      points.push(b.w + ',' + b.h);
      points.push('0,' + b.h);
      if (i > 0) {
        // Leftmost breadcrumb; don't include 6th vertex.
        points.push(b.t + ',' + b.h / 2);
      }
      return points.join(' ');
    }

    // Update the breadcrumb trail to show the current sequence and percentage.
    function updateBreadcrumbs(nodeArray, total, size) {
      // Data join; key function combines name and depth (= position in sequence).
      const g = d3
        .select(statSequence)
        .select('#stat-trail')
        .selectAll('g')
        .data(nodeArray, d => d.name + d.depth);

      // Add breadcrumb and label for entering nodes.
      const entering = g.enter().append('svg:g');

      entering
        .append('svg:polygon')
        .attr('points', breadcrumbPoints)
        .style('fill', d => getColor(d.name));

      const labelText = d => {
        const max = 22;
        if (d.name.length > max) {
          return `${d.name.substr(0, max -3)}...`;
        }
        return d.name;
      };

      entering
        .append('svg:text')
        .attr('x', (b.w + b.t) / 2)
        .attr('y', b.h / 2)
        .attr('width', b.w)
        .attr('dy', '0.35em')
        .attr('text-anchor', 'middle')
        .text(d => labelText(d));

      // Set position for entering and updating nodes.
      g.attr('transform', (d, i) => 'translate(' + i * (b.w + b.s) + ', 0)');

      // Remove exiting nodes.
      g.exit().remove();

      // Now move and update the percentage at the end.
      d3.select(statSequence)
        .select('#stat-trail')
        .select('#stat-endlabel')
        .attr('x', (nodeArray.length + 0.5) * (b.w + b.s))
        .attr('y', b.h / 2)
        .attr('dy', '0.35em')
        .attr('text-anchor', 'middle')
        .text(() => {
          if (size && totalSize) return `${total} (${Math.round(size * 1000 / totalSize) / 10}%)`;
          return total;
        });

      // Make the breadcrumb trail visible, if it's hidden.
      d3.select(statSequence)
        .select('#stat-trail')
        .style('visibility', '');
    }

    function drawLegend(rootNodes) {
      // Dimensions of legend item: width, height, spacing, radius of rounded rect.
      const cR = width / 50;
      const r = cR > 15 ? 15 : cR < 6 ? 6 : cR;
      const li = {
        // w: Math.min(width - height, width / 3),
        w: isDashboardPdf ? width * 5 : width,
        h: r * 2,
        s: 3,
        r: r
      };

      let sortFunc = (a, b) => b.value.data - a.value.data;
      if (sortKeys.orderDirs && sortKeys.orders) {
        if (sortKeys.orders[0] === 'measure' && sortKeys.orderDirs[0] === 'asc') {
          sortFunc = (a, b) => a.value.data - b.value.data;
        } else if (sortKeys.orders[0] === sortKeys.drill1 &&
          sortKeys.orderDirs[0] === 'asc') {
          sortFunc = (a, b) => a.key > b.key ? 1 : (a.key == b.key ? 0 : -1);
        } else if (sortKeys.orders[0] === sortKeys.drill1 &&
          sortKeys.orderDirs[0] === 'desc') {
          sortFunc = (a, b) => a.key > b.key ? -1 : (a.key == b.key ? 0 : 1);
        }
      }

      const legendData = rootNodes.children ? rootNodes.children.reduce((acc, ch) => {
        acc[ch.name] = {
          data: ch.value,
          dimension: ch.filter.dimension,
          label: ch.name,
          text: `${ch.name} (${Math.round(ch.value * 1000 / rootNodes.value)/10}%)`,
          value: ch.filter.value,
        };
        return acc;
      }, {}) : {};

      const entries = d3
        .entries(legendData)
        .map(entry => {
          entry.val = getColor(entry.key);
          return entry;
        })
        .sort(sortFunc);

      const mlen = entries.length * (li.h + li.s);

      const legend = d3
        .select(statLegend)
        .append('svg:svg')
        .attr('width', li.w)
        .attr('height', mlen);

      const g = legend
        .selectAll('g')
        .data(entries)
        .enter()
        .append('svg:g')
        .attr('transform', (d, i) => 'translate(0,' + i * (li.h + li.s) + ')')
        .style('pointer-events', 'all')
        .style('cursor', 'pointer')
        .style('fill', _this.fontColor)
        .on('click', d => {
          if (d.key == allOther) return;
          _this.router.drilldownFilter(d.value);
          _this.$rootScope.$digest();
        });

      g.append('svg:rect')
        .attr('x', '10px')
        .attr('rx', li.r)
        .attr('ry', li.r)
        .attr('width', li.h) //"20px"//li.w)
        .attr('height', li.h)
        .style('stroke', 'white')
        .style('stroke-width', '1')
        .style('fill', d => d.val)
        .style('opacity', 1);

      g.append('svg:text')
        .attr('x', li.h + 15)
        .attr('y', li.h / 2)
        .attr('dy', '0.35em')
        .attr('width', li.w - li.h)
        .attr('text-anchor', 'left')
        .text(d => Measure.getMeasure(d.value.data, _this.aggregate.filter.measure));

      g.append('svg:text')
        .attr('x', li.h + 10 + getLegendWidth(g))
        .attr('y', li.h / 2)
        .attr('dy', '0.35em')
        .attr('width', li.w - li.h)
        .attr('text-anchor', 'left')
        .text(d => d.value.text);

      _this.maxLegendWidth = Math.round(getLegendWidth(g));

      _this.legendWidth = width / 3;

      const minLegendWidth = _this.legendWidth;
      const fontMin = 10;
      const fontMax = 14;
      let font = 14;
      const k = (minLegendWidth - _this.maxLegendWidth / 2) / minLegendWidth;
      if (_this.maxLegendWidth > minLegendWidth) {
        if (k > 0) font = fontMin + (fontMax - fontMin) * k;
        else font = fontMin;
      }
      statLegend.style.fontSize = font + 'px';
    }

    // Take a 2-column CSV and transform it into a hierarchical structure suitable
    // for a partition layout. The first column is a sequence of step names, from
    // root to leaf, separated by hyphens. The second column is a count of how
    // often that sequence occurred.

    if (json) createVisualization(json);
  }
}

export const PieComponent = {
  template: require('./pie.component.html'),
  bindings: {
    model: '<',
    filter: '<',
    aggregate: '<'
  },
  controller: PieController
};



// WEBPACK FOOTER //
// ./src/stat/pie.component.js